import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const { isDarkMode } = useTheme();
  
  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className={`min-h-[calc(100vh-4rem)] flex items-center justify-center ${isDarkMode ? 'bg-blue-900' : 'bg-amber-50'}`}>
        <img 
          src="/favicon.svg" 
          alt="Loading..." 
          className="w-16 h-16 animate-spin"
        />
      </div>
    );
  }
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;